import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import {
    BrowserRouter as Router, Route, Switch
} from "react-router-dom";
import SignIn from './components/SignIn';
import OrderBook from './components/OrderBook';


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        color: "white"
    },

}));

export default function Main() {

    let [loggedIn, setLoggedIn] = useState(false);

    const classes = useStyles();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();


    let [token, setToken] = useState("unset");
    let [currentUser, setCurrentUser] = useState(undefined);

    return (
        <>
            <Router>
                <Switch>
                    <Route exact path="/">
                        <Grid container justify="center" style={{ paddingTop: 60 }}>
                            <Grid item xs={12} md={12}>
                                <OrderBook isLoggedIn={loggedIn} token={token} />
                            </Grid>
                        </Grid>
                    </Route>

                    <Route path="/signin">
                        <Grid container justify="center" style={{ paddingTop: 100 }}>
                            <Grid item xs={12} md={10} >
                                <SignIn />
                            </Grid>
                        </Grid>
                    </Route>
                </Switch>
            </Router>
        </>
    );


}